<template>
  <b-modal ref="projectInfoModal" title="案件一覧" :no-close-on-backdrop="true" :hide-footer="true">
    <b-overlay :show="overlayShow" rounded="sm">
      <table class="table mb-1 col-12 col-sm-12">
        <tbody>
          <tr class="mt-3">
            <th style="width: 27%; border-top: none; padding: 0;">披露宴開始時間</th>
            <th style="width: 38%; border-top: none; padding: 0;">ご両家名</th>
            <th style="width: 12%; border-top: none; padding: 0;">使用数</th>
            <th style="width: 23%; border-top: none; padding: 0;">担当者</th>
          </tr>
          <tr v-for="(pInfo, index) in projectInfo" :key="index">
            <td class="pr-2 pl-2 pt-0 pb-0 small" style="border-top: none; border-bottom: none;">{{pInfo['weddingTimeFrom']}}</td>
            <td class="pr-2 pl-2 pt-0 pb-0 small" style="border-top: none; border-bottom: none;"><a :href="pInfo['estimateURL']" target="_blank">{{pInfo['bothFamilyNames']}}</a></td>
            <td class="pr-2 pl-2 pt-0 pb-0 small text-right" style="border-top: none; border-bottom: none;">{{pInfo['materialNumber']}}</td>
            <td class="pr-2 pl-2 pt-0 pb-0 small" style="border-top: none; border-bottom: none;">{{pInfo['meetingPerson']}}</td>
          </tr>
        </tbody>
      </table>
    </b-overlay>
  </b-modal>
</template>

<script>

export default {
  name: 'ProjectInfoModal',
  data () {
    return {
      overlayShow: false,
      projectInfo: []
    }
  },
  async mounted () {
  },
  methods: {
    showModal (projectInfo) {
      this.$refs.projectInfoModal.show()
      this.projectInfo = projectInfo
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ProjectInfoModal.vue